var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6944 4.55279C29.6944 4.55279 29.4018 2.48453 28.4999 1.57697C27.358 0.382524 26.0791 0.375024 25.4941 0.305644C21.2995 1.9559e-07 14.9991 0 14.9991 0H14.9878C14.9878 0 8.68929 1.9559e-07 4.49278 0.305644C3.90587 0.376899 2.62891 0.382524 1.48697 1.57697C0.585037 2.48453 0.298144 4.55279 0.298144 4.55279C0.298144 4.55279 0 6.97919 0 9.41121V11.6857C0 14.1121 0.298144 16.5442 0.298144 16.5442C0.298144 16.5442 0.590662 18.6124 1.48697 19.5218C2.62891 20.7163 4.12901 20.6769 4.79842 20.8044C7.20045 21.0332 15.0009 21.1026 15.0009 21.1026C15.0009 21.1026 21.307 21.0913 25.5016 20.7913C26.0885 20.7219 27.3655 20.7144 28.5074 19.52C29.4093 18.6124 29.7019 16.5423 29.7019 16.5423C29.7019 16.5423 30 14.1159 30 11.6839V9.40934C29.9944 6.98294 29.6962 4.55091 29.6962 4.55091L29.6944 4.55279ZM11.892 14.444V6.01163L19.9962 10.2419L11.892 14.444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.73e21f0dd35052947f6fe538b2c0a2d6.svg";
export { ForwardRef as ReactComponent };